module.exports = __webpack_public_path__ + "static/media/limpieza.2fd54813.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/limpieza.svg
// module id = 201
// module chunks = 0